import { useState } from 'react';

const btsSchoolModel = () => {
  const initialState = {
    proposal: {
      id: 0,
      schoolName: '',
      businessManager: '',
      phoneNumber: '',
      booklistType: '',
      email: '',
      salesRep: {
        id: 0,
      },
      schoolLogoUrl: '',
      financialYear: '',
      status: '',
      createdDate: '',
      updatedDate: '',
    },
    logo: null,
  };
  const [btsSchool, setBtsSchool] = useState(initialState);

  const resetBtsSchool = () => {
    setBtsSchool(initialState);
  };

  return { btsSchool, setBtsSchool, resetBtsSchool, initialState };
};

export default btsSchoolModel;
